export let globalData = { 
    //for checking birthday and filter outdated server reply
    inputDate: undefined 
} 